'use client';
import React from 'react';

const PostsDetail = () => {
  return <div></div>;
};

export default PostsDetail;
